import React from 'react';
import { myWalletCreditCardDetailsView } from '@wix/bi-logger-cashier-ugc/v2';
import { getBiLogger } from '../../../../utils/biLogger';
import { CardDetailsWrapperConnect } from './view.connect';
import { ICardDetailsWrapperControllerConnectedProps } from './controller.connect';

export type ICardDetailsWrapperControllerProps = {
  children: React.ReactChildren | React.ReactNode;
};

export class CardDetailsWrapperController extends React.Component<
  React.PropsWithChildren<ICardDetailsWrapperControllerConnectedProps & ICardDetailsWrapperControllerProps>
> {
  componentDidMount() {
    getBiLogger().report(
      myWalletCreditCardDetailsView({
        cardId: this.props.cardId,
      }),
    );
  }

  render() {
    return <CardDetailsWrapperConnect>{this.props.children}</CardDetailsWrapperConnect>;
  }
}
